<template>
  <div class="container">
    <el-menu router
             @open="handleOpen"
             @close="handleClose"
             collapse-transition
             :default-active="$route.path">
      <el-submenu index="/support">
        <template slot="title">
          <img src="./assets/support.svg"
               alt="">
          <span style="margin-left:13px">开发支持</span>
          <img v-if="!expandFlag"
               src="./assets/downarrow.svg"
               alt=""
               style="margin-left:30px">
          <img v-else
               src="./assets/uparrow.svg"
               alt=""
               style="margin-left:30px">
        </template>
        <el-menu-item-group title="API文档"
                            class="group-title">
          <el-menu-item index="/support/search">搜索</el-menu-item>
          <el-menu-item index="/support/routing">路线规划</el-menu-item>
          <el-menu-item index="/support/geo">地理编码</el-menu-item>
          <el-menu-item index="/support/regeo">位置描述</el-menu-item>
          <el-menu-item index="/support/division">行政区域查询</el-menu-item>
          <el-menu-item index="/support/mapmatch">地图匹配</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group title="实用工具"
                            class="group-title">
          <el-menu-item index="/support/status">状态码说明</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-menu-item class="updatelog"
                    style="
          font-family: PingFangSC-Semibold;
          font-size: 16px;
          color: rgba(0, 0, 0, 1);
          font-weight: 600;
        "
                    index="/support/updatelog">
        <img src="./assets/updatelog.svg"
             alt="">
        <span slot="title"
              style="margin-left:12px">更新日志</span>
      </el-menu-item>
    </el-menu>
    <div class="document-container">
      <router-view />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      expandFlag: true
    };
  },
  created() {
    //
  },
  methods: {
    handleOpen(key, keyPath) {
      this.expandFlag = true;
    },
    handleClose(key, keyPath) {
      //
      this.expandFlag = false;
      const path = this.$route.path.split('/').pop();
      if (path !== 'updatelog') {

        // document.querySelector('.el-submenu').style.backgroundColor = 'red';

      }
      // if()
    }
  },
  computed: {}
};
</script>
<style lang="less" scoped>
.container {
  background-color: #fff;
  padding: 12px 0 30px 12px;
  border-radius: 18px;
  width: 1200px;
  margin: 24px 0;
  display: flex;

  .document-container {
    // flex: 1;
    width: 900px;
    margin-left: 48px;
  }
}
.el-menu {
  border: none;
  width: 180px;
  /deep/ .el-menu-item-group__title {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.3);
    font-weight: 400;
    line-height: 20px;
    padding-left: 54px !important;
  }
  /deep/ .el-submenu__title {
    font-family: PingFangSC-Semibold;
    font-size: 16px;
    color: rgba(0, 0, 0, 1);
    font-weight: 600;
    height: 46px;
    line-height: 46px;
    border-radius: 12px;
  }
  /deep/ .el-submenu__title:hover {
    background-image: linear-gradient(
      -45deg,
      rgba(255, 231, 95, 1) 0%,
      rgba(255, 209, 0, 1) 100%
    );
  }
  .el-menu-item {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.6);
    height: 46px;
    line-height: 46px;
    font-weight: 400;
    border-radius: 12px;
    min-width: 180px !important;
    padding-left: 46px;
    margin-bottom: 1px;
  }
  /deep/.el-submenu .el-menu-item {
    padding-left: 54px !important;
  }
  /deep/[class*=' el-icon-'],
  /deep/[class^='el-icon-'] {
    //删除了导航菜单上的小箭头
    display: none !important;
  }

  /deep/ .el-menu-item:hover {
    background-color: #f5f5f7 !important;
  }
  /deep/ .el-menu-item.is-active {
    font-family: PingFangSC-Semibold;
    color: rgba(0, 0, 0, 1);
    font-weight: 600;
    background-image: linear-gradient(
      -45deg,
      rgba(255, 231, 95, 1) 0%,
      rgba(255, 209, 0, 1) 100%
    );
  }
}
</style>
<style>
/* .side-memu .el-menu--inline .el-menu-item:hover {
  color: #000 !important;
  background: #ffdb66 !important;
  border-radius: 12px;
}
.el-submenu.side-memu .el-submenu__title:hover {
  color: #000 !important;
  background: #ffdb66 !important;
  border-radius: 12px;
} */
</style>
